import React from 'react';
import usePatient from '~/utils/patient/hook';
import { UncontrolledTable } from '~/components';

import NoteCell from '~/components/Patient/Identity/NoteCell';
import { format } from 'date-fns';
import { TableFilterDateRange, TableFilterIdentitySource } from '~/components/Filters';
import { MatchStatus } from '~/utils/const/identity';

const FosterCareClinicVisits = () => {
  const [, { sacwisPersonId: sacwisId }] = usePatient();

  return (
    <UncontrolledTable
      name="foster-care-clinic-visits"
      className="mx-4"
      endpoint={{
              url: 'data/public/list-view-cs-tbl-checkvisits',
              params: {
                sacwisId,
                match_status_id: MatchStatus.Approved,
                'visitdateTs__<<': format(new Date(), 'MM/DD/YYYY'),
              },
            }}
      defaultSorted={[{ id: 'visitdateTs__>>', desc: true }]}
      columns={[{
              id: 'visitdateTs__>>',
              Header: 'Visit Date',
              accessor: 'attributes.visitdateTs',
              cellType: 'date',
              Filter: d => <TableFilterDateRange {...d} />,
            }, {
              id: 'prcvisittype',
              Header: 'Visit Type',
              accessor: 'attributes.prcvisittype',
            }, {
              id: 'sourceDescription',
              Header: 'Reporting Healthcare Insitution',
              accessor: 'attributes.sourceDescription',
              Filter: d => <TableFilterIdentitySource {...d} />,
            }, {
              id: 'hasNotes',
              Header: 'Notes',
              accessor: 'attributes.hasNotes',
              filterable: false,
              Cell: n => <NoteCell {...n} />,
            }]}
      SubComponent={({ original: row }) => (
        <div className="p-3">
          <h6 className="text-primary">Diagnosis</h6>
          {row.attributes.additionaldx ? row.attributes.additionaldx : 'none'}
        </div>
            )}
    />
  );
};

export default FosterCareClinicVisits;
